import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.o12_1 = this;
        this.p12_1 = this;
        this.q12_1 = false;
      }
      r12(node, permissionsBitmask) {
        var prev = this.p12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.k1m_1 & permissionsBitmask) === 0 && prev.r12(node, permissionsBitmask));
        } else {
          node.o12_1 = this;
          node.p12_1 = prev;
          prev.o12_1 = node;
          this.p12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      g15(forbiddenElementsBit) {
        this.r12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      s12() {
        if (this.q12_1)
          return false;
        var prev = this.p12_1;
        var next = this.o12_1;
        prev.o12_1 = next;
        next.p12_1 = prev;
        this.q12_1 = true;
        return true;
      }
      t12(node) {
        if (!(this.o12_1 === this))
          return false;
        this.r12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.k1m_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
